/**
 * @title TradeIn Page - Add item button
 * @description The main tradein page, this is the button
 */
import {AddItemButton, GlobalLayout, StyledTypography} from "../../../providers/layout/LayoutProvider";
import {AddItemIcon} from "../../../svg/SvgIcons";
import * as React from "react";
import {MouseEventHandler, useState} from "react";
import {useRecoilValue} from "recoil";
import {GraphQL} from "../../../utility/GraphQL";
import {AppDataAtom} from "../../../providers/access/ApplicationDataProvider";
import {ReturnsSum} from "./ReturnsCart";
import {LocalizationsAtom} from "../../../providers/localization/LocalizationProvider";
import {Box} from "@mui/material";
import {Currency} from "../../../components/Currency";

type AddButtonProps = {
   isEmpty: boolean
   onClick?: MouseEventHandler<any> | undefined;
   children?: React.ReactNode | React.ReactNode[]
   disabled?: boolean
}

export const AddButton = ({isEmpty, children, disabled, onClick}: AddButtonProps) => {
   const globalLayout = useRecoilValue(GlobalLayout);
   const [clicked, setClicked] = useState<boolean>(false);
   const appData = useRecoilValue(AppDataAtom);
   const sum = useRecoilValue(ReturnsSum);

   let emptyButton = globalLayout.widgets?.addItemButtonBlank;
   let normalButton = globalLayout.widgets?.addItemButton;

   if (!emptyButton || GraphQL.isEmpty(emptyButton)) {
      emptyButton = normalButton
   }

   const onHandleClick = (e: any) => {
      if (clicked) {
         return;
      }
      setClicked(true);
      onClick && onClick(e);
   }
   let addItemButtonStyle = isEmpty ? emptyButton : normalButton;

   const effectiveDisablet = disabled || (appData.maximumVoucher > 0 && sum > appData.maximumVoucher)
   let buttonColor = addItemButtonStyle?.textColor || '#000000';

   return <Box sx={{textAlign: 'center'}}>
      <MaximumVoucherWarning/>
      <AddItemButton isEmpty={isEmpty}
                     disabled={effectiveDisablet}
                     startIcon={(!globalLayout.disableIcons && !globalLayout.widgets?.addItemIconHide) &&
                        <AddItemIcon iconsize={'16px'} iconcolor={buttonColor}/>}
                     onClick={onHandleClick}
                     className={'c2s-newitem'}>
         {children}
      </AddItemButton>
   </Box>
}

const MaximumVoucherWarning = () => {
   const localizations = useRecoilValue(LocalizationsAtom);
   const appData = useRecoilValue(AppDataAtom);
   const sum = useRecoilValue(ReturnsSum);

   if (appData.maximumVoucher && sum > appData.maximumVoucher) {
      return <Box sx={{
         display: 'flex',
         flexDirection: 'row',
         justifyContent: 'center',
         alignItems: 'center',
         textAlign: 'center',
         backgroundColor: '#FDE6E7',
         marginBottom: '20px',
         padding: '5px 10px 5px 10px',
         borderRadius: '4px'
      }}>
         <StyledTypography component={"span"} sx={{color: '#DE061C'}} variant={"body1"}
                           type={"main"}>
            {localizations.tradeInMaximumCart}
            {localizations.tradeInMaximumCart2 ? <Box>
               {localizations.tradeInMaximumCart2}
               &nbsp;
               <Currency amount={appData.maximumVoucher}/>
            </Box> : <>&nbsp;
               <Currency amount={appData.maximumVoucher}/>
            </>
            }
         </StyledTypography>
      </Box>
   } else {
      return null;
   }
}
